//tabService.js
import API_BASE_URL from "../../../../../Constants";

export const updateViolations = async (violationsData) => {
    const id = violationsData?.VioldationID;

    try {
        const response = await fetch(`${API_BASE_URL}/api/violations/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(violationsData),
            credentials: "include",
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update violation");
        }

        return response.json();
    } catch (error) {
        throw new Error("Failed to update violation");
    }
}

export const updateInspection = async (inspectionData) => {
    const id = inspectionData?.inspectionId;

    try {
        const response = await fetch(`${API_BASE_URL}/api/inspections/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(inspectionData),
            credentials: "include",
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to update inspection");
        }

        return response.json();
    } catch (error) {
        throw new Error("Failed to update inspection");
    }
}
